import { makeStyles } from '@material-ui/core/styles';
import { SecondTypeCard } from 'api/generated';
import { FC } from 'react';
import { DeleteButton, SaveButton, Toolbar, ToolbarProps } from 'react-admin';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const SecondTypeCardToolbar: FC<ToolbarProps> = (props) => {
  const secondTypeCardRecord = props.record as SecondTypeCard;
  const { title } = secondTypeCardRecord;
  return (
    <Toolbar {...props} classes={useStyles()}>
      <SaveButton label="Save" disabled={props.pristine} />
      <DeleteButton
        confirmTitle="Recommendation remove"
        confirmContent={`Are you sure you want to delete item "${title}"?`}
        label="Remove"
        mutationMode="optimistic"
      />
    </Toolbar>
  );
};
